import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './styles.css';
import ENDPOINT from '../../../../constants/endpoints';
import ROUTE from '../../../../constants/route';
import LinkBuilder from '../../../../helpers/link-builder';
import {Role, showNoCandidateProfileDialog} from '../../../../helpers/user';
import useApi from '../../../../hooks/useApi';

const RelatedJobs = props => {
  const { user, history } = props;
  const api = useApi();
  const [records, setRecords] = useState([]);

  useEffect(() => {
    api.get(
      ENDPOINT.COLLECTION.JOBS_YMK,
      {},
      {
        handleSuccess: data =>
          setRecords(Object.keys(data).map(key => data[key])),
      }
    );
  }, [api]);

  const handleClickViewAll = () => {
    if (!user.isLoggedIn) {
      window.location = '/signup';
    } else if (Role.isCandidate(user, true)) {
      history.push(ROUTE.JOBS);
    }
  };

  const renderRows = useMemo(() => {
    const isAnonymous = Role.isAnonymous(user);
    const isCandidate = Role.isCandidate(user);

    return records.map(job => (
      <div className="related-jobs-block__job" key={job.ProcessID}>
        {isCandidate ? (
          <NavLink
            to={LinkBuilder.getJobLink(job.ProcessID)}
            className="related-jobs-block__job-title"
          >
            {job.PositionTitle}
          </NavLink>
        ) : (
          <span
            className="related-jobs-block__job-title"
            onClick={() => {
              if (!isAnonymous) {
                showNoCandidateProfileDialog(user);
              } else if (job.BlockLinkedInSharing === 'No') {
                history.push(
                  LinkBuilder.getProcessPublicLink(job.Id, 'process')
                );
              } else {
                window.location = '/signup';
              }
            }}
          >
            {job.PositionTitle}
          </span>
        )}
        <span className="related-jobs-block__description">{job.FirmName}</span>
      </div>
    ));
  }, [history, records, user]);

  return records.length > 0 ? (
    <div className="related-jobs-block">
      <h3 className="related-jobs-block__title">Jobs You May Like</h3>
      <div className="related-jobs-block__list">{renderRows}</div>
      <span
        onClick={handleClickViewAll}
        className="related-jobs-block__view-more"
      >
        View More
      </span>
    </div>
  ) : null;
};

RelatedJobs.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default RelatedJobs;
